import { render } from "./Widget7.vue?vue&type=template&id=7cbde492"
import script from "./Widget7.vue?vue&type=script&lang=js"
export * from "./Widget7.vue?vue&type=script&lang=js"
script.render = render

export default script